<script lang="ts" setup>
import BackgroundImage from '@/page/infrastructure/components/BackgroundImage.vue';
import { useUrlHelper } from '@/page/infrastructure/composition/useUrlHelper';

const { getBaseUrl } = useUrlHelper();
</script>

<template>
  <BackgroundImage img="/assets/img/coveredCalifornia/half-half-family.jpg" alt="Girl skating" width="960" height="717" id="life-happens" reverse>
    <div class="flex flex-col space-y-6">
      <span class="text-2xl lg:text-3xl font-bold text-black">What Does The California Health Exchange Do?</span>
      <p>
        The Exchange helps Californians comply with the Obamacare mandate. It helps individuals and families
        <a :href="getBaseUrl('/covered-california/insurance')" class="text-blue-500 hover:underline">obtain health coverage</a>
        that includes the minimum essential benefits required by the law. Certain carriers are certified to offer
        subsidized
        <a :href="getBaseUrl('/covered-california/plans')" class="text-blue-500 hover:underline">Obama Care Plans and Full Price plans</a>
        and dental plans through the Exchange. These
        <a :href="getBaseUrl('/covered-california/health-insurance-companies')" class="text-blue-500 hover:underline">carriers</a>
        can sell insurance on or off the Exchange. But for qualified consumers, rates can be better if the medical
        plan is purchased through the marketplace.
      </p>
      <p>
        For people with a household income that is below 400% of the
        <a :href="getBaseUrl('/federal-poverty-level')" class="text-blue-500 hover:underline">Federal Poverty Level</a>
        (“FPL”), Covered Ca may qualify them to receive financial assistance, also called a
        “<a :href="getBaseUrl('/covered-california/subsidy-tax-credits')" class="text-blue-500 hover:underline">Subsidy</a>”,
        which reduces their premium. And if income is between 138% and 250% of the FPL, the State Exchange may also
        qualify individuals for extra discounts that reduce their cost for medical services. These extra discounts are
        referred to as
        “<a :href="getBaseUrl('/covered-california/cost-sharing')" class="text-blue-500 hover:underline">Cost Sharing Reductions</a>”.
        To be eligible for a subsidy and potentially for cost sharing reductions, you must fall within
        <a :href="getBaseUrl('/covered-california/income-limits')" class="text-blue-500 hover:underline">Covered California income limits</a>
        and not be offered affordable, full coverage healthcare through an employer, Medicare, etc. Enrollments need
        to be submitted through the State Marketplace, a Certified Insurance Agent, or a Certified Enrollment
        Counselor.
      </p>
    </div>
  </BackgroundImage>
</template>
